import type { SlSelect } from '@shoelace-style/shoelace';

export const ALL_YEAR_GROUPS = 'ALL_YEAR_GROUPS';

/**
 * Extract the value from a <YearGroupSelect> select element within a submitted form.
 * @param e The submit event.
 * @param id The base id shared with the <YearGroupSelect> component's `@id` arg.
 * @returns The selected year group, or undefined if no year group is selected.
 */
export default function extractYearGroup(e: SubmitEvent, id: string) {
  const form = e.target as HTMLFormElement;
  const selectId = `#${id}-year-groups`;
  const selectElement = form.querySelector(selectId) as SlSelect | null;
  let selectedYearGroup;

  if (selectElement) {
    const rawValue = selectElement.value;
    // Note that sl-select can return string or string[].
    selectedYearGroup = Array.isArray(rawValue) ? rawValue[0] : rawValue;

    if (selectedYearGroup === ALL_YEAR_GROUPS) {
      // keep underscores so const doesn't change
      selectedYearGroup = undefined;
    } else {
      // add spaces back in (see underscoreize helper)
      selectedYearGroup = selectedYearGroup?.replace(/_/g, ' ');
    }
  }

  return selectedYearGroup;
}
